module.exports = __webpack_public_path__ + "img/1.a2db3c6.png";